(function() {

	angular
		.module('ngmvac')
		.filter('starsFilter', StarsFilter);

	function StarsFilter() {
		var comparisonCriteria = {
			'one': ['1EST', 'H1_5'],
			'two': ['2EST', '2', 'H2_5'],
			'three': ['3EST', '3', 'H3_5'],
			'four': ['4EST', '4LUX', 'H4_5'],
			'five': ['5EST', '5LUX', 'H5_5']
		}
		

		return function(arr, stars) {
			var arrAux = [];
			var applyFilter;
			
			for( key in stars ) {
				if( stars[key] == true ) {
					applyFilter = true;
				}
			}

			if( applyFilter ) {
				angular.forEach( arr, function(hotel, index) {
					for( key in stars ) {
						if( stars[key] ) {
							angular.forEach( comparisonCriteria[key], function( cat, indexCat ) {
								if( hotel.categoryCode == cat ) {
									arrAux.push(hotel);
								}
							});
						}
					}
				});
				return arrAux;
			}

			return arr;
		}
	}

})();